module.exports = __webpack_public_path__ + "static/media/redux-toolkit.e45538fd.svg";